import { render, staticRenderFns } from "./AirReport.vue?vue&type=template&id=6e2822b4&scoped=true"
import script from "./AirReport.vue?vue&type=script&lang=js"
export * from "./AirReport.vue?vue&type=script&lang=js"
import style0 from "./AirReport.vue?vue&type=style&index=0&id=6e2822b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2822b4",
  null
  
)

export default component.exports